import { ProposalQuoteOption } from '@/types/management.types'

export const mockProposal: ProposalQuoteOption[] = [
  {
    id: 'quote-1',
    status: 'En espera',
    proposalGeneralInfo: {
      fecha: '2025-08-11',
      nombreCliente: 'Juan Pérez García',
      atencionA: 'María González',
      tipoDeActivo: 'Vehículo',
      numeroCotizaciones: 3,
    },
    vehicleData: {
      marca: 'Toyota',
      modelo: 'Camry',
      submarcaVersion: 'XLE Premium',
      tipo: 'Sedán',
      valorFactura: '450000',
      costoAccesorios: '25000',
      descripcionAccesorios:
        'Sistema de navegación GPS, llantas de aleación, polarizado',
      periodoCotizacion: '24 meses',
    },
    adjustments: {
      leaseTerm: 24,
      advancePayment: 20,
      residualValue: 45,
      guaranteeDeposit: 2,
    },
    conditions: {
      leaseAmount: '375000',
      insurance: '8500',
      totalInitialAmount: '83500',
      openingFee: '3000',
      residualValueNoTax: '168750',
      monthlyRentNoTax: '12450',
      monthlyDiscount: '500',
      totalRentWithDiscount: '11950',
      rentTax: '1912',
      reserveFund: '750',
      totalRentWithTax: '14612',
    },
    created_at: '',
  },
  {
    id: 'quote-2',
    status: 'En espera',
    proposalGeneralInfo: {
      fecha: '2025-08-11',
      nombreCliente: 'Juan Pérez García',
      atencionA: 'María González',
      tipoDeActivo: 'Vehículo',
      numeroCotizaciones: 3,
    },
    vehicleData: {
      marca: 'Honda',
      modelo: 'Accord',
      submarcaVersion: 'EX-L V6',
      tipo: 'Sedán',
      valorFactura: '420000',
      costoAccesorios: '20000',
      descripcionAccesorios:
        'Techo solar, asientos de cuero, sistema de audio premium',
      periodoCotizacion: '36 meses',
    },
    adjustments: {
      leaseTerm: 36,
      advancePayment: 15,
      residualValue: 40,
      guaranteeDeposit: 2,
    },
    conditions: {
      leaseAmount: '380000',
      insurance: '9200',
      totalInitialAmount: '66200',
      openingFee: '3000',
      residualValueNoTax: '152000',
      monthlyRentNoTax: '9850',
      monthlyDiscount: '300',
      totalRentWithDiscount: '9550',
      rentTax: '1528',
      reserveFund: '600',
      totalRentWithTax: '11678',
    },
    created_at: '',
  },
  {
    id: 'quote-3',
    status: 'En espera',
    proposalGeneralInfo: {
      fecha: '2025-08-11',
      nombreCliente: 'Juan Pérez García',
      atencionA: 'María González',
      tipoDeActivo: 'Vehículo',
      numeroCotizaciones: 3,
    },
    vehicleData: {
      marca: 'Nissan',
      modelo: 'Altima',
      submarcaVersion: 'SR Turbo',
      tipo: 'Sedán',
      valorFactura: '390000',
      costoAccesorios: '15000',
      descripcionAccesorios:
        'Spoiler deportivo, rines deportivos, escape deportivo',
      periodoCotizacion: '48 meses',
    },
    adjustments: {
      leaseTerm: 48,
      advancePayment: 10,
      residualValue: 35,
      guaranteeDeposit: 2,
    },
    conditions: {
      leaseAmount: '400000',
      insurance: '10500',
      totalInitialAmount: '50500',
      openingFee: '3000',
      residualValueNoTax: '140000',
      monthlyRentNoTax: '8200',
      monthlyDiscount: '200',
      totalRentWithDiscount: '8000',
      rentTax: '1280',
      reserveFund: '500',
      totalRentWithTax: '9780',
    },
    created_at: '',
  },
]
